import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const CustomerIdCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer id",
    cell: (row) => {
      return row.customer?.id ?? "";
    },
  };
